import { RadioChangeEvent } from 'antd';
import React, { useState } from 'react';
import { IngestionSourceList } from './source/IngestionSourceList';
import { SecretsList } from './secret/SecretsList';
import { SearchHeader } from '../search/SearchHeader';
import { IngestionTabType } from '../shared/admin/HeaderLinks';
import { useTranslation } from '../../i18n/useTranslation';

export const ManageIngestionPage = () => {
    const { t } = useTranslation();

    /**
     * Determines which view should be visible: ingestion sources or secrets.
     */
    const [selectedTab, setSelectedTab] = useState<IngestionTabType>(IngestionTabType.Sources);

    const handleModeChange = (e: RadioChangeEvent) => {
        setSelectedTab(e.target.value);
    };

    return (
        <>
            <SearchHeader
                ingestionTabType={selectedTab}
                handleIngestionModeChange={handleModeChange}
                subtext={t('CREATE_SCHEDULE_RUN_INGESTION_PIPELINES_DESC')}
            >
                {selectedTab === IngestionTabType.Sources ? <IngestionSourceList /> : <SecretsList />}
            </SearchHeader>
        </>
    );
};
